import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SocialAuthService } from "angularx-social-login";
import * as CryptoJS from "crypto-js";
import { NgxSpinnerService } from "ngx-spinner";
import { take } from "rxjs/operators";
import Swal from "sweetalert2";
import Api from "../../../helpers/api";
import App from "../../../helpers/app";
import { ImageCropperService } from "../../../helpers/image-cropped";
import Me from "../../../helpers/me";
import { ModalCropComponent } from "../../../modules/modal-crop/modal-crop.component";
import { AuthService } from "../../../shared/auth/auth.service";
import { error } from "console";
declare var Iugu: any;
@Component({
  selector: "app-infos",
  templateUrl: "./infos.component.html",
  styleUrls: ["./infos.component.scss"],
})
export class InfosComponent implements OnInit {
  apiCall = this.api.new().silent();
  acceptPromoMessages = null;
  acceptPromoMessagesCustomers = null;
  user = null;
  showCropper = false;
  cropped: string;
  imageType: "banner" | "capa";
  formUpdateSenha = {
    password: null,
    newPassword: null,
    confirmPassword: null,
  };
  selectedColor = null;
  fileToCrop: File | null = null;
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required]),
  });

  activeId = 1;

  urlToPlay = null;
  safeURL = null;
  constructor(
    private modal: NgbModal,
    private router: Router,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private socialAuthService: SocialAuthService,
    private app: App,
    private _sanitizer: DomSanitizer,
    private imageCropperService: ImageCropperService,
    private api: Api
  ) {
    this.me
      .get()
      .pipe(take(1))
      .toPromise()
      .then((user) => {
        this.user = user;
        let jUser = null;
        jUser = JSON.parse(JSON.stringify(this.user));

        if (jUser) {
          this.acceptPromoMessages = jUser.acceptPromoMessages;
          this.acceptPromoMessagesCustomers =
            jUser.acceptPromoMessagesCustomers;
        }
      });

    this.route.params.subscribe((params) => {
      if (params["destId"]) {
        this.activeId = +params["destId"];
      }
    });
  }

  async ngOnInit() {
    await this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const user = await this.me.get(false).pipe(take(1)).toPromise();
    this.user = this.formatTelUser(user);
    const dataColor = await this.apiCall
      .get("me/userparams/appBaseColor")
      .pipe(take(1))
      .toPromise();
    this.selectedColor = dataColor.return ? dataColor.return.value : "#2ebfca";
    this.phoneForm.patchValue({
      phone: this.user.phone,
    });
    await this.spinner.hide();
  }
  async verifyFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      let retorno = "";
      reader.onload = function (theFile) {
        var image = new Image();
        image.src = theFile.target.result.toString();
        image.onload = function () {
          // access image size here
          if (image.width != 414 || image.height != 150) {
            resolve(
              "a proporção da imagem está invalida! É obrigatório utilizar a proporção de 414px x 150px"
            );
          } else {
            resolve(null);
          }
        };
      };
    });
  }
  async fileToBase64(file) {
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  async changeBanner() {
    try {
      const { value: file } = await Swal.fire({
        title: `<p style=" font-family: Montserrat; font-size: 12px; font-weight: 600; line-height: 14.63px; text-align: center;">Novo Banner</p>`,
        html: `
         <div style="border: 2px dashed #9E9E9E; margin: 0px">
          <div class="row" style="display: flex; flex-direction: row;
           align-items: center; justify-content: center; margin: 26px;">
            <div class="col-auto">
              <label class="btn btn-sm btn-warning" style="cursor: pointer;">
                Escolher Arquivo
                <input type="file" id="fileInputBanner" style="display: none;" accept="image/*"/>
              </label>
            </div>
            <div class="col-auto">
              <div class="row">
                <div class="col-auto" style="display: flex; align-items: center; font-family: Montserrat; font-size: 10px; font-weight: 500; line-height: 9.75px;">
                  <label>
                    <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <rect y="0.5" width="9" height="12" fill="url(#pattern0_11_149)"/>
                      <defs>
                        <pattern id="pattern0_11_149" patternContentUnits="objectBoundingBox" width="1" height="1">
                          <use xlink:href="#image0_11_149" transform="matrix(0.00266667 0 0 0.002 -0.111111 0)"/>
                        </pattern>
                        <image id="image0_11_149" width="500" height="500" src="/src/assets/icons/icon-file-play.png"/>
                      </defs>
                    </svg>
                    Tipo de Arquivo
                  </label>
                </div>
                <div style="color: var(--cinza-escuro-4, #757575); font-family: Montserrat;
                font-size: 10px; font-weight: 400; line-height: 10.97px; text-align: center;">
                  <p style="margin-bottom: 10px; margin-left: 18px; margin-rigth:4px">jpeg, jpg, png</p>
                </div>
              </div>
              <div class="row">
                <div class="col-auto" style="display: flex; align-items: center; font-family: Montserrat; font-size: 10px; font-weight: 500; line-height: 9.75px;">
                  <label>
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.833344 3.33333V1.66667C0.833344 1.55616 0.877242 1.45018 0.955382 1.37204C1.03352 1.2939 1.1395 1.25 1.25001 1.25H3.75001C3.86052 1.25 3.9665 1.2939 4.04464 1.37204C4.12278 1.45018 4.16668 1.55616 4.16668 1.66667C4.16668 1.77717 4.12278 1.88315 4.04464 1.96129C3.9665 2.03943 3.86052 2.08333 3.75001 2.08333H1.66668V3.33333C1.66668 3.44384 1.62278 3.54982 1.54464 3.62796C1.4665 3.7061 1.36052 3.75 1.25001 3.75C1.1395 3.75 1.03352 3.7061 0.955382 3.62796C0.877242 3.54982 0.833344 3.44384 0.833344 3.33333ZM8.75001 1.25H6.25001C6.1395 1.25 6.03352 1.2939 5.95538 1.37204C5.87724 1.45018 5.83334 1.55616 5.83334 1.66667C5.83334 1.77717 5.87724 1.88315 5.95538 1.96129C6.03352 2.03943 6.1395 2.08333 6.25001 2.08333H8.33334V3.33333C8.33334 3.44384 8.37724 3.54982 8.45538 3.62796C8.53352 3.7061 8.6395 3.75 8.75001 3.75C8.86052 3.75 8.9665 3.7061 9.04464 3.62796C9.12278 3.54982 9.16668 3.44384 9.16668 3.33333V1.66667C9.16668 1.55616 9.12278 1.45018 9.04464 1.37204C8.9665 1.2939 8.86052 1.25 8.75001 1.25ZM1.25001 8.75H3.75001C3.86052 8.75 3.9665 8.7061 4.04464 8.62796C4.12278 8.54982 4.16668 8.44384 4.16668 8.33333C4.16668 8.22283 4.12278 8.11685 4.04464 8.0387C3.9665 7.96057 3.86052 7.91667 3.75001 7.91667H1.66668V6.66667C1.66668 6.55616 1.62278 6.45018 1.54464 6.37204C1.4665 6.2939 1.36052 6.25 1.25001 6.25C1.1395 6.25 1.03352 6.2939 0.955382 6.37204C0.877242 6.45018 0.833344 6.55616 0.833344 6.66667V8.33333C0.833344 8.44384 0.877242 8.54982 0.955382 8.62796C1.03352 8.7061 1.1395 8.75 1.25001 8.75ZM8.75001 6.25C8.6395 6.25 8.53352 6.2939 8.45538 6.37204C8.37724 6.45018 8.33334 6.55616 8.33334 6.66667V7.91667H6.25001C6.1395 7.91667 6.03352 7.96057 5.95538 8.0387C5.87724 8.11685 5.83334 8.22283 5.83334 8.33333C5.83334 8.44384 5.87724 8.54982 5.95538 8.62796C6.03352 8.7061 6.1395 8.75 6.25001 8.75H8.75001C8.86052 8.75 8.9665 8.7061 9.04464 8.62796C9.12278 8.54982 9.16668 8.44384 9.16668 8.33333V6.66667C9.16668 6.55616 9.12278 6.45018 9.04464 6.37204C8.9665 6.2939 8.86052 6.25 8.75001 6.25ZM2.50001 3.75V6.25C2.50001 6.36051 2.54391 6.46649 2.62205 6.54463C2.70019 6.62277 2.80617 6.66667 2.91668 6.66667H7.08334C7.19385 6.66667 7.29983 6.62277 7.37797 6.54463C7.45611 6.46649 7.50001 6.36051 7.50001 6.25V3.75C7.50001 3.63949 7.45611 3.53351 7.37797 3.45537C7.29983 3.37723 7.19385 3.33333 7.08334 3.33333H2.91668C2.80617 3.33333 2.70019 3.37723 2.62205 3.45537C2.54391 3.53351 2.50001 3.63949 2.50001 3.75Z"
                          fill="black"
                        />
                      </svg>
                      Proporção Necessária
                    </label>
                  </div>
                  <div style="margin: 0px; color: var(--cinza-escuro-4, #757575); font-family: Montserrat; font-size: 10px;
                    font-weight: 400;
                    line-height: 10.97px;
                    text-align: center; justify-content: center">
                      <p style=" margin-left: 2px; margin-right:16px">414px x 150px</p>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    `,
        showCancelButton: true,
        cancelButtonText: `Cancelar`,
        confirmButtonText: `Salvar`,
        preConfirm: async () => {
          return new Promise<File>((resolve, reject) => {
            const fileInput = document.getElementById(
              "fileInputBanner"
            ) as HTMLInputElement;
            const file = fileInput?.files?.[0];

            if (!file) {
              reject(new Error("Você precisa escolher um banner!"));
            } else if (!file.type.startsWith("image/")) {
              this.app.alert(
                "Você precisa escolher um arquivo de imagem válido!",
                "error"
              );
              reject(
                new Error("Você precisa escolher um arquivo de imagem válido!")
              );
            } else if (file.size > 2000000) {
              this.app.alert("São permitidos arquivos de até 2MB!", "error");
              reject(new Error("São permitidos arquivos de até 2MB!"));
            } else {
              resolve(file);
            }
          });
        },
      });

      if (file) {
        console.log("Arquivo selecionado:", file);
        this.fileToCrop = file;
        this.imageType = "banner";
        this.openCropModal(file, "banner");
      } else {
        console.log("Nenhum arquivo selecionado");
      }
    } catch (e) {
      console.error("Erro ao selecionar o arquivo:", e.message);
      Swal.fire({
        icon: "error",
        title: "Erro ao selecionar o arquivo",
        text: e.message,
      });
      Swal.getInput().addEventListener("input", (event: Event) => {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
          const file = input.files[0];
          if (file && file instanceof File) {
            this.fileToCrop = file;
            this.imageType = "banner";
            this.openCropModal(file, "banner");
            Swal.close();
          }
        }
      });
    }
  }

  async changeCapaPlataforma() {
    try {
      const { value: file } = await Swal.fire({
        title: `<p style=" font-family: Montserrat; font-size: 12px; font-weight: 600; line-height: 14.63px; text-align: center;">Nova Capa</p>`,
        html: `
          <div style="border: 2px dashed #9E9E9E; margin: 0px">
          <div class="row" style="display: flex; flex-direction: row;
           align-items: center; justify-content: center; margin: 26px;">
            <div class="col-auto">
              <label class="btn btn-sm btn-warning" style="cursor: pointer;">
                Escolher Arquivo
                 <input type="file" id="fileInputCapa" style="display: none;" accept="image/*"/>
              </label>
            </div>
            <div class="col-auto">
              <div class="row">
                <div class="col-auto" style="display: flex; align-items: center; font-family: Montserrat; font-size: 10px; font-weight: 500; line-height: 9.75px;">
                  <label>
                    <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <rect y="0.5" width="9" height="12" fill="url(#pattern0_11_149)"/>
                      <defs>
                        <pattern id="pattern0_11_149" patternContentUnits="objectBoundingBox" width="1" height="1">
                          <use xlink:href="#image0_11_149" transform="matrix(0.00266667 0 0 0.002 -0.111111 0)"/>
                        </pattern>
                        <image id="image0_11_149" width="500" height="500" src="/src/assets/icons/icon-file-play.png"/>
                      </defs>
                    </svg>
                    Tipo de Arquivo
                  </label>
                </div>
                <div style="color: var(--cinza-escuro-4, #757575); font-family: Montserrat;
                font-size: 10px; font-weight: 400; line-height: 10.97px; text-align: center;">
                  <p style="margin-bottom: 10px; margin-left: 16px;">jpeg, png</p>
                </div>
              </div>
              <div class="row">
                <div class="col-auto" style="display: flex; align-items: center; font-family: Montserrat; font-size: 10px; font-weight: 500; line-height: 9.75px;">
                  <label>
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.833344 3.33333V1.66667C0.833344 1.55616 0.877242 1.45018 0.955382 1.37204C1.03352 1.2939 1.1395 1.25 1.25001 1.25H3.75001C3.86052 1.25 3.9665 1.2939 4.04464 1.37204C4.12278 1.45018 4.16668 1.55616 4.16668 1.66667C4.16668 1.77717 4.12278 1.88315 4.04464 1.96129C3.9665 2.03943 3.86052 2.08333 3.75001 2.08333H1.66668V3.33333C1.66668 3.44384 1.62278 3.54982 1.54464 3.62796C1.4665 3.7061 1.36052 3.75 1.25001 3.75C1.1395 3.75 1.03352 3.7061 0.955382 3.62796C0.877242 3.54982 0.833344 3.44384 0.833344 3.33333ZM8.75001 1.25H6.25001C6.1395 1.25 6.03352 1.2939 5.95538 1.37204C5.87724 1.45018 5.83334 1.55616 5.83334 1.66667C5.83334 1.77717 5.87724 1.88315 5.95538 1.96129C6.03352 2.03943 6.1395 2.08333 6.25001 2.08333H8.33334V3.33333C8.33334 3.44384 8.37724 3.54982 8.45538 3.62796C8.53352 3.7061 8.6395 3.75 8.75001 3.75C8.86052 3.75 8.9665 3.7061 9.04464 3.62796C9.12278 3.54982 9.16668 3.44384 9.16668 3.33333V1.66667C9.16668 1.55616 9.12278 1.45018 9.04464 1.37204C8.9665 1.2939 8.86052 1.25 8.75001 1.25ZM1.25001 8.75H3.75001C3.86052 8.75 3.9665 8.7061 4.04464 8.62796C4.12278 8.54982 4.16668 8.44384 4.16668 8.33333C4.16668 8.22283 4.12278 8.11685 4.04464 8.0387C3.9665 7.96057 3.86052 7.91667 3.75001 7.91667H1.66668V6.66667C1.66668 6.55616 1.62278 6.45018 1.54464 6.37204C1.4665 6.2939 1.36052 6.25 1.25001 6.25C1.1395 6.25 1.03352 6.2939 0.955382 6.37204C0.877242 6.45018 0.833344 6.55616 0.833344 6.66667V8.33333C0.833344 8.44384 0.877242 8.54982 0.955382 8.62796C1.03352 8.7061 1.1395 8.75 1.25001 8.75ZM8.75001 6.25C8.6395 6.25 8.53352 6.2939 8.45538 6.37204C8.37724 6.45018 8.33334 6.55616 8.33334 6.66667V7.91667H6.25001C6.1395 7.91667 6.03352 7.96057 5.95538 8.0387C5.87724 8.11685 5.83334 8.22283 5.83334 8.33333C5.83334 8.44384 5.87724 8.54982 5.95538 8.62796C6.03352 8.7061 6.1395 8.75 6.25001 8.75H8.75001C8.86052 8.75 8.9665 8.7061 9.04464 8.62796C9.12278 8.54982 9.16668 8.44384 9.16668 8.33333V6.66667C9.16668 6.55616 9.12278 6.45018 9.04464 6.37204C8.9665 6.2939 8.86052 6.25 8.75001 6.25ZM2.50001 3.75V6.25C2.50001 6.36051 2.54391 6.46649 2.62205 6.54463C2.70019 6.62277 2.80617 6.66667 2.91668 6.66667H7.08334C7.19385 6.66667 7.29983 6.62277 7.37797 6.54463C7.45611 6.46649 7.50001 6.36051 7.50001 6.25V3.75C7.50001 3.63949 7.45611 3.53351 7.37797 3.45537C7.29983 3.37723 7.19385 3.33333 7.08334 3.33333H2.91668C2.80617 3.33333 2.70019 3.37723 2.62205 3.45537C2.54391 3.53351 2.50001 3.63949 2.50001 3.75Z"
                          fill="black"
                        />
                      </svg>
                      Proporção Necessária
                    </label>
                  </div>
                  <div style="margin: 0px; color: var(--cinza-escuro-4, #757575); font-family: Montserrat; font-size: 10px;
                    font-weight: 400;
                    line-height: 10.97px;
                    text-align: center; justify-content: center">
                      <p style=" margin-left: 2px; margin-right:16px">1980px x 480px</p>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      `,
        showCancelButton: true,
        inputAttributes: {
          accept: "image/*",
          "aria-label":
            "Faça upload da sua foto de Capa. Sugerimos proporção de 1980px x 480px.",
        },
        preConfirm: async () => {
          return new Promise<File>((resolve, reject) => {
            const fileInput = document.getElementById(
              "fileInputCapa"
            ) as HTMLInputElement;
            const file = fileInput?.files?.[0];

            if (!file) {
              reject(new Error("Você precisa escolher uma capa!"));
            } else if (!file.type.startsWith("image/")) {
              this.app.alert(
                "Você precisa escolher um arquivo de imagem válido!",
                "error"
              );
              reject(
                new Error("Você precisa escolher um arquivo de imagem válido!")
              );
            } else if (file.size > 2000000) {
              this.app.alert("São permitidos arquivos de até 2MB!", "error");
              reject(new Error("São permitidos arquivos de até 2MB!"));
            } else {
              resolve(file);
            }
          });
        },
      });

      if (file) {
        this.fileToCrop = file;
        this.imageType = "capa";
        this.openCropModal(file, "capa");
      } else {
        console.log("Nenhum arquivo selecionado");
      }
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Erro ao selecionar o arquivo",
        text: e.message,
      });
      Swal.getInput().addEventListener("input", (event: Event) => {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
          const file = input.files[0];
          if (file && file instanceof File) {
            this.fileToCrop = file;
            this.imageType = "capa";
            this.openCropModal(file, "capa");
            Swal.close();
          }
        }
      });
    }
  }

  handleCroppedImage(croppedImage: string) {
    console.log("Handling cropped image:", croppedImage);
    this.cropped = croppedImage;
    this.uploadCroppedImage(croppedImage, this.imageType); // Passe o imageType
  }

  openCropModal(file: File, type: "banner" | "capa") {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const modalRef = this.modal.open(ModalCropComponent, {
        centered: true,
        size: "lg",
      });
      modalRef.componentInstance.source = reader.result as string;
      modalRef.componentInstance.aspectRatio =
        type === "banner" ? 69 / 25 : 33 / 8;
      modalRef.componentInstance.croppedImageEvent.subscribe(
        (croppedImage: string) => {
          console.log(
            "Cropped image event received in profile component:",
            croppedImage
          );
          this.imageType = type; // Defina o imageType
          this.handleCroppedImage(croppedImage);
        }
      );
      modalRef.result
        .then((croppedImage: string) => {
          console.log("Modal closed with cropped image:", croppedImage);
          if (croppedImage) {
            this.imageType = type; // Defina o imageType
            this.handleCroppedImage(croppedImage);
          }
        })
        .catch((error: any) => {
          console.log("Modal dismissed with error:", error);
        });
    };
    reader.onerror = (error) => {
      console.error("Error reading file:", error);
    };
  }

  async uploadCroppedImage(croppedImage: string, imageType: "banner" | "capa") {
    const self = this;

    const blob = await fetch(croppedImage).then((r) => r.blob());
    const fileName = "cropped_image.jpg";
    const fileToUpload = new File([blob], fileName, { type: blob.type });

    var reader = new FileReader();
    reader.readAsArrayBuffer(blob);
    reader.onload = async function () {
      var file_result = this.result;
      var file_wordArr = CryptoJS.lib.WordArray.create(
        file_result as ArrayBuffer
      );
      var sha1_hash = CryptoJS.SHA1(file_wordArr);
      let sha1 = sha1_hash.toString();

      await self.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });

      const dataUrl = await self.apiCall
        .get("blackbaze/urltoupload")
        .pipe(take(1))
        .toPromise();
      if (!dataUrl.return) {
        await self.spinner.hide();
        return;
      }

      if (
        dataUrl.return &&
        dataUrl.return.authorizationToken &&
        dataUrl.return.uploadUrl &&
        dataUrl.return.uniqid
      ) {
        var optionsB2 = {
          headers: {
            Authorization: dataUrl.return.authorizationToken,
            "Content-Type": fileToUpload.type,
            "X-Bz-File-Name":
              dataUrl.return.uniqid.toString() +
              "." +
              fileToUpload.name.split(".").pop(),
            "X-Bz-Content-Sha1": sha1,
          },
        };
        const returnedUpload = await self.api.http
          .post(dataUrl.return.uploadUrl, fileToUpload, optionsB2)
          .toPromise();
        await self.spinner.hide();
        if (returnedUpload) {
          const uploadedFileUrl =
            "https://files.wecodde.com/file/wecodde/" +
            JSON.parse(JSON.stringify(returnedUpload)).fileName;

          if (imageType === "capa") {
            self.user.capaPlataforma = uploadedFileUrl;
            self.updateUser();
            await self.apiCall
              .put("users/objectives/update/4")
              .pipe(take(1))
              .toPromise();
          } else if (imageType === "banner") {
            self.user.banner = uploadedFileUrl;
            self.updateUser();
            await self.apiCall
              .put("users/objectives/update/5")
              .pipe(take(1))
              .toPromise();
          }
        }
      }
    };
  }

  async changePhoto() {
    const self = this;
    const { value: file } = await Swal.fire({
      title: "Nova Foto de Perfil",
      input: "file",
      text: "Sugerimos proporção de 140px x 140px",
      showCancelButton: true,
      cancelButtonText: `Cancelar`,
      confirmButtonText: `Salvar`,
      inputAttributes: {
        accept: "image/*",
        "aria-label":
          "Faça upload de sua foto de perfil. Sugerimos proporção de 140 x 140.",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Você precisa escolher uma nova foto!";
        }
      },
    });

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        let arquivo = reader.result.toString();
        self.spinner.show(undefined, {
          type: "ball-triangle-path",
          size: "medium",
          bdColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          fullScreen: true,
        });
        self.apiCall
          .put("seller/me/picture", { picture: arquivo })
          .subscribe(async (data) => {
            self.me.refresh().subscribe(async (u) => {
              self.user = u;
              self.spinner.hide();
              if (data.success) {
                this.user = this.formatTelUser(this.user);

                await this.app.alert(
                  "Tudo certo!",
                  "Sua foto de perfil foi atualizada com sucesso",
                  "success"
                );
              } else {
                await this.app.alert("Ops :(", data.message, "error");
              }
              location.reload();
            });
          });
      };
      reader.onabort = () => {};
      reader.onerror = () => {};
    }
  }

  async updateUser() {
    const self = this;
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    if (
      this.phoneForm &&
      this.phoneForm.controls["phone"] &&
      this.phoneForm.controls["phone"].value &&
      this.phoneForm.controls["phone"].value.e164Number
    ) {
      this.user.phone = this.phoneForm.controls["phone"].value.e164Number;
    }

    let userToSend = this.user;
    if (userToSend.phone && !userToSend.phone.toString().startsWith("+")) {
      userToSend.phone = "+" + userToSend.phone;
    }
    this.me
      .update(userToSend)
      .then(async (data) => {
        this.user = this.formatTelUser(this.user);
        await self.spinner.hide();
        await self.app.alert(
          "Tudo certo!",
          "Seu usuário foi atualizado com sucesso",
          "success"
        );
        this.ngOnInit();
      })
      .catch(async (error) => {
        await self.spinner.hide();
        await this.app.alert(
          "Ops :(",
          "Ocorreu algum erro ao atualizar seus dados",
          "error"
        );
      });
  }

  formatTelUser(user) {
    if (user) {
      if (user.phone && !user.phone.toString().startsWith("+")) {
        user.phone = "+" + user.phone;
      }
    }
    return user;
  }
  async updatePassword() {
    const self = this;
    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    self.me
      .updatePassword({
        password: this.formUpdateSenha.password,
        newPassword: this.formUpdateSenha.newPassword,
        confirmPassword: this.formUpdateSenha.confirmPassword,
      })
      .pipe(take(1))
      .toPromise()
      .then(async (data) => {
        this.user = this.formatTelUser(this.user);

        self.spinner.hide();
        await this.app.alert(
          "Tudo certo!",
          "Sua senha foi atualizada com sucesso",
          "success"
        );
      })
      .catch(async (error) => {
        await self.spinner.hide();
        await this.app.alert("Ops :(", error.message, "error");
      });
  }

  updateAcceptPromoMessages(modal) {
    const self = this;
    console.log(this.acceptPromoMessages);

    Swal.fire({
      title: "Tem certeza?",
      text: this.acceptPromoMessages
        ? "Deseja ativar as mensagens promocionais?"
        : "Deseja desativar as mensagens promocionais?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        self.spinner.show(undefined, {
          type: "ball-triangle-path",
          size: "medium",
          bdColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          fullScreen: true,
        });

        self.apiCall
          .put("seller/me/updateacceptpromomessages", {
            acceptPromoMessages: this.acceptPromoMessages,
          })
          .subscribe(async (data) => {
            if (data.success) {
              self.user = await this.me.get(false).pipe(take(1)).toPromise();
              this.spinner.hide();
              await this.app.alert(
                "Tudo certo!",
                "Preferência da mensagem promocional alterada com sucesso",
                "success"
              );
              modal.close("Close click");
              this.ngOnInit();
            } else {
              await this.app.alert("Ops :(", data.message, "error");
            }
          });
      } else if (result.isDismissed) {
        this.acceptPromoMessages = !this.acceptPromoMessages;
      }
    });
  }

  updateAcceptPromoMessagesCustomers(modal) {
    const self = this;
    console.log(this.acceptPromoMessagesCustomers);

    Swal.fire({
      title: "Tem certeza?",
      text: this.acceptPromoMessagesCustomers
        ? "Deseja ativar as mensagens promocionais para seus alunos?"
        : "Deseja desativar as mensagens promocionais para seus alunos?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        self.spinner.show(undefined, {
          type: "ball-triangle-path",
          size: "medium",
          bdColor: "rgba(0, 0, 0, 0.8)",
          color: "#fff",
          fullScreen: true,
        });

        self.apiCall
          .put("seller/me/updateacceptpromomessagescustomers", {
            acceptPromoMessagesCustomers: this.acceptPromoMessagesCustomers,
          })
          .subscribe(async (data) => {
            if (data.success) {
              self.user = await this.me.get(false).pipe(take(1)).toPromise();
              this.spinner.hide();
              await this.app.alert(
                "Tudo certo!",
                "Preferência da mensagem promocional alterada com sucesso",
                "success"
              );
              modal.close("Close click");
              this.ngOnInit();
            } else {
              await this.app.alert("Ops :(", data.message, "error");
            }
          });
      } else if (result.isDismissed) {
        this.acceptPromoMessagesCustomers = !this.acceptPromoMessagesCustomers;
      }
    });
  }

  OpenModalXl(content) {
    this.modal.open(content, { centered: true, size: "xl" });
  }

  viewMidia(urlToPlay, content) {
    this.urlToPlay = urlToPlay;
    if (urlToPlay.startsWith("https://www.youtube.com/watch?")) {
      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
        urlToPlay.replace(
          "https://www.youtube.com/watch?v=",
          "https://www.youtube.com/embed/"
        )
      );
    } else if (urlToPlay.startsWith("http://www.youtube.com/watch?")) {
      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
        urlToPlay.replace(
          "http://www.youtube.com/watch?v=",
          "https://www.youtube.com/embed/"
        )
      );
    }
    this.modal.open(content, { centered: true, size: "lg" });
  }

  saveColor() {
    const self = this;
    const value = self.selectedColor;
    console.log("color", value);

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    self.apiCall
      .put("me/userparams/appBaseColor", { value })
      .subscribe(async (data) => {
        if (data.success) {
          this.spinner.hide();
          await this.app.alert(
            "Tudo certo!",
            "Preferência salva com sucesso!",
            "success"
          );
          this.ngOnInit();
        } else {
          this.spinner.hide();

          await this.app.alert("Ops :(", data.message, "error");
        }
      });
  }

  resetAppColor() {
    const self = this;

    self.app
      .confirm(
        "Tem certeza?",
        "Você realmente deseja deletar a cor personalizada?"
      )
      .then((d) => {
        if (d) {
          self.spinner.show(undefined, {
            type: "ball-triangle-path",
            size: "medium",
            bdColor: "rgba(0, 0, 0, 0.8)",
            color: "#fff",
            fullScreen: true,
          });

          self.apiCall
            .delete("me/userparams/appBaseColor")
            .subscribe(async (data) => {
              if (data.success) {
                this.spinner.hide();
                await this.app.alert(
                  "Tudo certo!",
                  "Preferência de cor resetada com sucesso!",
                  "success"
                );
                this.ngOnInit();
              } else {
                await this.app.alert("Ops :(", data.message, "error");
              }
            });
        }
      });
  }
}
